import ReactComponentRegistry from 'react_component_registry';
import $ from 'jquery';
import { industryIdentification } from './constants/configurations_industry_identification_exp';

import { getAnswersFromStorage } from './storage_helpers';

const getTier = surveyAnswer => {
  if (surveyAnswer.WORKERS_TYPE === 'contractor_only') {
    return 'contractor_only';
  }
  return surveyAnswer.tier;
};

const getHasPaidW2 = surveyAnswer => {
  if (surveyAnswer.PREV_PAYROLL_PROVIDER === 'new') {
    return 'No, we haven’t paid anyone';
  }
  if (surveyAnswer.WORKERS_TYPE === 'contractor_only') {
    return 'No, we’ve only paid 1099 contractors';
  }
  return surveyAnswer.WORKERS_TYPE;
};

const getPreviousPayrollProvider = surveyAnswer => {
  if (surveyAnswer.PREV_PAYROLL_PROVIDER === 'new') {
    return 'I don’t know';
  }
  return surveyAnswer.PREV_PAYROLL_PROVIDER;
};

export default function submitForm(values, formikSetSubmitting, submissionOrigin = null) {
  // Map survey answers to the appropriate field
  // Make sure these are the right field
  const surveyAnswer = getAnswersFromStorage();

  const companyLead = values.company_lead;
  companyLead.tier = getTier(surveyAnswer);

  const discoverySurvey = {};
  discoverySurvey.has_paid_w2 = getHasPaidW2(surveyAnswer);
  discoverySurvey.ran_historical_payroll_on_signup_year = surveyAnswer.RUN_PAYROLL;
  discoverySurvey.previous_payroll_provider = getPreviousPayrollProvider(surveyAnswer);
  discoverySurvey.industry_identification = surveyAnswer.INDUSTRY_IDENTIFICATION
    ? industryIdentification[surveyAnswer.INDUSTRY_IDENTIFICATION]
    : '';

  // If tier is contractor_only, these questions should have been skipped
  if (companyLead.tier !== 'contractor_only') {
    companyLead.hi_interest = surveyAnswer.HEALTH_BENEFITS;
  }

  $.ajax({
    url: '/homepage-survey/company',
    dataType: 'json',
    method: 'POST',
    data: {
      authenticity_token: ReactComponentRegistry.authenticityToken(),
      company_lead: companyLead,
      discovery_survey: discoverySurvey,
      user: values.user,
      tier_source: surveyAnswer.tier_source,
      submission_origin: submissionOrigin,
    },
  })
    .done(res => {
      GustoAnalytics.track({
        eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
        eventName: 'SurveySignupAnswerSubmitted',
        data: {
          company_lead: companyLead,
          survey_answer: surveyAnswer,
        },
      });

      window.location.href = res.redirect_url;
    })
    .fail(({ status, responseText }) => {
      formikSetSubmitting(false);
      Bugsnag.notify(new Error(`[SurveySignupModal] Failed with status: ${status}`), {
        metaData: { message: responseText },
      });
    });
}
